"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptOrchestrator = void 0;
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Prompt_1 = require("./Prompt");
var PromptTypes_1 = require("Prompt/PromptTypes");
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var PromptOrchestrator = (function () {
    function PromptOrchestrator(useHistoryDataStore, usingFeature) {
        this.useHistoryDataStore = useHistoryDataStore;
        this.imagesInSidebarEnabled = usingFeature(FeatureFlag_1.default.SidebarImages);
    }
    PromptOrchestrator.prototype.getPrompt = function (promptableRef, id) {
        var _a;
        var promptableRect = promptableRef.current.getBoundingClientRect();
        var staticProps = {
            heading: this.getHeading(id),
            body: this.getBody(id),
            onShow: this.getViewFn(id),
            onDismiss: this.getDismissFn(id),
            id: id,
            position: this.getPosition(id),
            useHistoryDataStore: this.useHistoryDataStore,
            top: this.getTop(id, promptableRect),
            left: this.getLeft(id, promptableRef.current, promptableRect),
        };
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
                return react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowEditTextPrompt" }));
            case PromptTypes_1.PromptId.Styles:
                return react_dom_1.default.createPortal(react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowStylePrompt", className: (0, classnames_1.default)({
                        "prompt--style-library-only": !((_a = promptableRef.current) === null || _a === void 0 ? void 0 : _a.children[0].className.includes("style-button--with-side-action")),
                    }) })), document.getElementsByClassName("project-block")[0]);
            case PromptTypes_1.PromptId.AddBlock:
                return react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowAddBlockPrompt" }));
            case PromptTypes_1.PromptId.Share:
                return react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowSharePrompt" }));
            case PromptTypes_1.PromptId.Comments:
                return react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowCommentsPrompt" }));
            case PromptTypes_1.PromptId.ContentLibrary:
                return react_1.default.createElement(Prompt_1.Prompt, __assign({}, staticProps, { useHistoryFieldName: "shouldShowContentLibraryPrompt" }));
        }
    };
    PromptOrchestrator.prototype.getHeading = function (id) {
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
                return "Edit text";
            case PromptTypes_1.PromptId.Styles:
                return "Style your blocks";
            case PromptTypes_1.PromptId.AddBlock:
                return "Add a block";
            case PromptTypes_1.PromptId.Share:
                return "Share your page";
            case PromptTypes_1.PromptId.Comments:
                return "New feature";
            case PromptTypes_1.PromptId.ContentLibrary:
                return "Meet your Library";
        }
    };
    PromptOrchestrator.prototype.getBody = function (id) {
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
                return "Highlight text to format and edit it, like to change the page heading";
            case PromptTypes_1.PromptId.Styles:
                return "Use the block style controls to change how your block looks";
            case PromptTypes_1.PromptId.AddBlock:
                return "Add more sections to your page, like text, videos and quotes";
            case PromptTypes_1.PromptId.Share:
                return "Send a sharing link to your page when it's ready, and you'll be notified once it's viewed";
            case PromptTypes_1.PromptId.Comments:
                return "Click the icon to add a comment, and keep collaborators on the same page";
            case PromptTypes_1.PromptId.ContentLibrary:
                return this.imagesInSidebarEnabled
                    ? "Drag and drop saved blocks and images into your page from the new Library Sidebar"
                    : "Drag and drop saved blocks into your page from the new Library Sidebar";
        }
    };
    PromptOrchestrator.prototype.getPosition = function (id) {
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
            case PromptTypes_1.PromptId.AddBlock:
            case PromptTypes_1.PromptId.Comments:
                return kaleidoscope_1.TooltipPosition.Top;
            case PromptTypes_1.PromptId.Styles:
            case PromptTypes_1.PromptId.Share:
            case PromptTypes_1.PromptId.ContentLibrary:
                return kaleidoscope_1.TooltipPosition.Bottom;
        }
    };
    PromptOrchestrator.prototype.getDismissFn = function (id) {
        var _this = this;
        return function () { return _this.useHistoryDataStore.dismissedPrompt(id); };
    };
    PromptOrchestrator.prototype.getViewFn = function (id) {
        var _this = this;
        return function () { return _this.useHistoryDataStore.viewedPrompt(id); };
    };
    PromptOrchestrator.prototype.getTop = function (id, promptableRect) {
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
                return 0;
            case PromptTypes_1.PromptId.Styles:
            case PromptTypes_1.PromptId.AddBlock:
                return -26;
            case PromptTypes_1.PromptId.Share:
                return -67;
            case PromptTypes_1.PromptId.Comments:
                return -20;
            case PromptTypes_1.PromptId.ContentLibrary:
                return this.imagesInSidebarEnabled ? -65 : -49;
            default:
                return promptableRect.top - 80;
        }
    };
    PromptOrchestrator.prototype.getLeft = function (id, promptableNode, promptableRect) {
        switch (id) {
            case PromptTypes_1.PromptId.EditText:
                if (promptableNode.children.length && promptableNode.children[0].children.length) {
                    return promptableNode.children[0].children[0].getBoundingClientRect().left - promptableRect.left;
                }
            case PromptTypes_1.PromptId.Styles:
                return 149;
            case PromptTypes_1.PromptId.AddBlock:
                return 0;
            case PromptTypes_1.PromptId.Share:
                return "50%";
            case PromptTypes_1.PromptId.Comments:
                return 12;
            case PromptTypes_1.PromptId.ContentLibrary:
                return 50;
            default:
                return (promptableRect.left + promptableRect.right) / 2;
        }
    };
    return PromptOrchestrator;
}());
exports.PromptOrchestrator = PromptOrchestrator;
